import { PosStorageKey } from './../../../../pos/services/storage.key';
import { StorageService } from './../../../../pos/services/storage.service';
import { PosMachineService } from 'src/app/services/api/pos-machine/pos-machine.service';
import { ChangeDetectorRef, Component, OnInit, AfterViewInit } from '@angular/core';
import { SessionService } from 'src/app/services/api/session/session.service';
import { Router } from '@angular/router';
import { PermissionService } from 'src/app/pos/services/permission.service';
import { AlertService } from 'src/app/pos/services/alert/alert.service';

@Component({
  selector: 'app-pos-matchine',
  templateUrl: './pos-matchine.component.html',
  styleUrls: ['./pos-matchine.component.scss'],
})
export class PosMatchineComponent implements OnInit, AfterViewInit {
  user: any;
  session: any;
  matchines: any;
  is_pos: any;
  isPos: boolean = true;
  isLoading: boolean = true;
  constructor(
    private sessionService: SessionService,
    private posMachineService: PosMachineService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private storageService: StorageService,
    private mobilePermissionService: PermissionService,
    private alertService: AlertService
  ) {}

  async ngAfterViewInit(): Promise<void> {
    // check mobile permission

    const checkPermission = this.mobilePermissionService.checkMobilePermission({
      key: 'การจัดการหน้าขาย',
      action: 'ทำรายการ',
    });

    if (!checkPermission) {
      await this.alertService.openDefaultDialog({
        title: 'ผิดพลาด! คุณไม่มีสิทธิ์เข้าใช้งานในส่วนนี้',
      });
      this.router.navigate(['']);
    }
  }

  ngOnInit(): void {
    this.getUser();
    this.getMatchines(this.user.system_account_id);
  }

  getUser(){
    this.session = this.sessionService.getSession();
    this.user = this.session.user;
    this.is_pos = this.user.role.role_permissions.filter((item) => item.permission_name != 'เข้าถึงระบบ POS');
    if (this.is_pos.length === 0) {
      this.isPos = true;
    } else {
      this.isPos = false;
    }
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 300);
    this.getMatchines(this.user.system_account_id);
  }

  getMatchines(id) {
    let params = {
      owner_id: id,
    };
    this.posMachineService.gets().subscribe((result: any) => {
      this.matchines = result;
      if (this.matchines.length != 0) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
      setTimeout(() => {
        this.cdr.detectChanges();
      }, 300);
    });
  }

  onClick(item) {
    sessionStorage.setItem('pos-matchines', JSON.stringify(item));
    this.storageService.set(PosStorageKey.pos, item);
    this.router.navigate(['/pos']);
  }

  logout() {
    this.sessionService.logout();
    sessionStorage.clear();
    // localStorage.clear();
    this.router.navigate(['/auth/login']);
  }
}
